import { slideUp, slideDown } from "es6-slide-up-down";

export default class BusinessHours {
	constructor() {
		this.businessHours = document.querySelectorAll(".business-hours-wrapper");
		this.businessHours.forEach((el, index) => {
			if (el.querySelector(".business-hours-current")) {
				el.addEventListener("click", () => {
					let weekly = el.querySelector(".business-hours-weekly");
					if (weekly.classList.contains("hidden")) {
						slideDown(weekly);
						weekly.classList.remove("hidden");
					} else {
						slideUp(weekly);
						weekly.classList.add("hidden");
					}
				});
			}
		});
	}
}
